import BluePrintDevelopment from './BlueprintDevelopment';
import ComplianceSection from './ComplainceSection';
import DiscoverBanner from './DiscoverBanner';
import HeroSection from './HeroSection';
import { LandingPageStyled } from './landing-styles';
import OurStrength from './OurStrength';
import ProfessionalSlogan from './ProfessionalSlogan';
import SimpleSmart from './SimpleSmart';
import StrategicChoice from './StrategicChoice';
import UserTypeSection from './UserTypeSection';
import WhyChooseUs from './WhyChooseUs';

const LandingPage = () => {
  return (
    <LandingPageStyled>
      <HeroSection />
      <ComplianceSection/>
      <ProfessionalSlogan />
      <UserTypeSection />
      <DiscoverBanner />
      <StrategicChoice />
      <BluePrintDevelopment />
      <OurStrength />
      <WhyChooseUs />
      <SimpleSmart />
    </LandingPageStyled>
  );
};

export default LandingPage;
